import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

export default class extends Controller {
  static targets = ["submitter"];
  static values = { debounce: Number };
  static debounces = ["submit"];

  connect() {
    useDebounce(this, {
      wait: this.hasDebounceValue ? this.debounceValue : 300,
      name: "submit",
    });
  }

  submit() {
    if (this.hasSubmitterTarget) {
      this.element.requestSubmit(this.submitterTarget);
    } else {
      this.element.requestSubmit();
    }
  }
}
